import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/it/impostazioni')({
  component: Outlet,
})
